import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {Backend} from '@common/backend'
import {useFileViewerStore} from '../file-viewer-store'
import IconDownload from '../icons/icon-download.svg'

const TwDownload = tw.div`
  font-normal
  truncate
  leading-4
  text-14
  text-secondary-old-dark
`

const TwWrapper = tw.div`
  flex
  select-none
  items-center
  gap-8
  cursor-pointer
  py-4
  px-8
  rounded-4
  hover:bg-project-hover-old-dark
  active:bg-main-old-dark
`

const toDataURL = async (url: string) => {
  const response = await fetch(Util.isDesktop() ? Backend.toDataUrl(url) : url)
  const blob = await response.blob()
  return URL.createObjectURL(blob)
}

const download = async (url: string, filename: string) => {
  const a = document.createElement('a')
  a.href = await toDataURL(url)
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export const downloadFile = (url: string | undefined, name: string) => {
  if (!url) {
    return
  }
  const decodeUrl = Util.safeDecodeUriComponent(url, url)
  void download(decodeUrl, name)
}

export const Download = observer(({onDownload}: {onDownload?: () => void}) => {
  const [state, store] = useFileViewerStore()
  const onClick = () => {
    downloadFile(state.currentFile?.url, store.name)
    onDownload?.()
  }
  return (
    <TwWrapper onClick={onClick}>
      <IconDownload className="text-secondary-old-dark" />
      <TwDownload>{Lang.msg.fileViewer.downloadFile}</TwDownload>
    </TwWrapper>
  )
})
